import React from "react";
function Navigation({name, className}) {
  return (
    <div className="navigation">
        <div className={`text ${className}`}>{name}</div>
    </div>
  )
}

export default Navigation